import { SET_ACTIVE_USER_TYPE } from 'redux/actionTypes';

export default function activeUserType(state= "", action) {
    switch(action.type){
        case SET_ACTIVE_USER_TYPE:
            return action.payload;
        default:
            return state;
    }
};